module.exports = __webpack_public_path__ + "images/paypal/logo-1f1b057a.svg";